module.exports = __webpack_public_path__ + "media/images/font-af5b71be7196d0f9008d35e27b83520b.svg";